// extracted by mini-css-extract-plugin
export default {"formWrapperDesktop":"a9uC6n","formWrapperShadow":"b9uC6n"};